import React, {useState,  useRef, useEffect } from 'react';
import {withRouter} from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import styles from "./OrganisationLicenceInformation.module.scss";
import {Button, ErrorMsg, AddressWrapped, OrganisationWrapped,} from "@onegovbugs/onegov-react-components";
import {storeOrganisationDetails, saveImportExportApplication} from "../../../redux/actions";
import {
  isCompleted,
  isValidEmail,
  isAustralianPhoneNumberOrNull,
  isDayTimeNumberOrNull,
  validate,
  scrollToError,
  isSelected
} from "../../../utils/Validation";
import ScrollToTop from "../../../utils/ScrollToTop";
import { RedirectIfCaptchaNotSelected } from "../../../utils/Redirect";  
import Select from "react-select";
import { getAddresUrlPath } from '../../../utils/AddressHelper';

const OrganisationLicenceInformation = props => {

  ScrollToTop();
  RedirectIfCaptchaNotSelected(props);
  
  const dispatch = useDispatch();  
  const addressRef = useRef();
  const [isAddressValid, setIsAddressValid] = useState(true);
  const [isAddressValidating, setAddressValidating] = useState(false);
  const [warnPartialMatch, setWarnPartialMatch] = useState(false);

  const organisationApplicationDetails = useSelector(state => state.organisationApplicationDetails);  

  const [title, setTitle] = useState(organisationApplicationDetails.title ? organisationApplicationDetails.title : null);
  const [firstname, setFirstname] = useState(organisationApplicationDetails && organisationApplicationDetails.firstname  ? organisationApplicationDetails.firstname : '');
  const [middlename, setMiddlename] = useState(organisationApplicationDetails && organisationApplicationDetails.middlename  ? organisationApplicationDetails.middlename : '');
  const [lastname, setLastname] = useState(organisationApplicationDetails && organisationApplicationDetails.lastname  ? organisationApplicationDetails.lastname : '');

  const [address, setAddress] = useState(organisationApplicationDetails && organisationApplicationDetails.address ? organisationApplicationDetails.address : '');
  const [emailAddress, setEmailAddress] = useState(organisationApplicationDetails && organisationApplicationDetails.emailAddress ? organisationApplicationDetails.emailAddress : '');
  const [dayTimeTelephoneNumber, setDayTimeTelephoneNumber] = 
    useState(organisationApplicationDetails && organisationApplicationDetails.dayTimeTelephoneNumber ? organisationApplicationDetails.dayTimeTelephoneNumber : '');  
  const [mobileNumber, setMobileNumber] = 
    useState(organisationApplicationDetails && organisationApplicationDetails.mobileNumber ? organisationApplicationDetails.mobileNumber : '');  

  const componentRef = React.createRef();
  const [abn, setAbn] = useState(organisationApplicationDetails && organisationApplicationDetails.abn ? organisationApplicationDetails.abn : '');
  const [acn, setAcn] = useState(organisationApplicationDetails && organisationApplicationDetails.acn ? organisationApplicationDetails.acn : '');
  const [organisationIdType, setOrganisationIdType] = 
    useState(organisationApplicationDetails && organisationApplicationDetails.organisationIdType  ? organisationApplicationDetails.organisationIdType : '');
  const [organisationBusinessName, setOrganisationBusinessName] = 
    useState(organisationApplicationDetails && organisationApplicationDetails.organisationBusinessName  ? organisationApplicationDetails.organisationBusinessName : '');
    
  const testTradingName = { value: 'COMMONWEALTH AWARDS', label: 'COMMONWEALTH AWARDS' };
  const [selectedTradingName, setSelectedTradingName] = useState(testTradingName);

  const getFinalAdddress = (adddressValue) => {
    let finalAdddress;

    finalAdddress = {
        addressNotChanged: false,
        ...adddressValue,
      };

    return finalAdddress;
  };

  const storeData = (finished) => {
    const organisationDetails ={
      title, firstname, middlename, lastname,
      emailAddress, mobileNumber, dayTimeTelephoneNumber,address: getFinalAdddress(address),
      organisationIdType, abn, acn, organisationBusinessName, finished, step: 1
    };
    dispatch(storeOrganisationDetails(organisationDetails));
  };

  const titleOptions = [
    {
      value: "mr",
      label: "Mr",
    },
    {
      value: "mrs",
      label: "Mrs",
    },
    {
      value: "miss",
      label: "Miss",
    },
    {
      value: "miss",
      label: "Ms",
    },
    {
      value: "sir",
      label: "Sir",
    },
    {
      value: "dr",
      label: "Dr",
    },
    {
      value: "prof",
      label: "Prof",
    },
    {
      value: "assocprof",
      label: "Assoc Prof",
    },
    {
      value: "rev",
      label: "Rev",
    },
    {
      value: "master",
      label: "Master",
    },
    {
      value: "father",
      label: "Father",
    },
    {
      value: "pastor",
      label: "Pastor",
    },
    {
      value: "sister",
      label: "Sister",
    },
  ];

  const [showErrors, setShowErrors] = useState(false);

    const [errors, setErrors] = useState({
      title: false,
      firstname: false,
      lastname: false,
      dayTimeTelephoneNumber: false,
      mobileNumber: false,
      emailAddress: false,
      address: false,
    });
    useEffect(() => {
      validate(validators, setErrors);
    }, [title, firstname, lastname, dayTimeTelephoneNumber, mobileNumber, emailAddress, address]);
  
    const validators = [
        {
          fieldName: "title",
          fieldValue: title,
          isValid: isSelected,
        },    
        {
            fieldName: 'firstname',
            fieldValue: firstname,
            isValid: isCompleted
        },
        {
            fieldName: 'lastname',
            fieldValue: lastname,
            isValid: isCompleted
        },
        {
            fieldName: 'dayTimeTelephoneNumber',
            fieldValue: dayTimeTelephoneNumber,
            isValid: v => isCompleted(v) && isDayTimeNumberOrNull(v),
        },                   
        {
            fieldName: 'mobileNumber',
            fieldValue: mobileNumber,
            isValid: isAustralianPhoneNumberOrNull
        },    
        {
            fieldName: 'emailAddress',
            fieldValue: emailAddress,
            isValid: isValidEmail
        },
        {
            fieldName: 'address',
            fieldValue: address,
            isValid: () => isAddressValid
        },
    ];



  return <div className={styles.mainCont}>
    <div className={"row"}>
      <div className={'col-12'}>
        <OrganisationWrapped
          regoType={organisationIdType}
          setRegoType={setOrganisationIdType}
          abn={abn}
          setAbn={setAbn}
          acn={acn}
          setAcn={setAcn}
          businessName={organisationBusinessName}
          setBusinessName={setOrganisationBusinessName}
          baseURL={process.env.REACT_APP_BASE_URL}
          disableYINC={true}
          hideTradingNameList={true}
          selectedTradingName={selectedTradingName}
          setSelectedTradingName={setSelectedTradingName}
          ref={componentRef}
        />      
      </div>
    </div> 

        <div className={"row"}>
          <div className={"col-12"}>
            <h2>Business Contact Details</h2>
          </div>
        </div>

        <div className={"row"}>

          <div className={"col-12 col-sm-6"}>
              <label htmlFor="title">Title</label>
              <Select
                  id={"inputTitle"}
                  value={title}
                  onChange={setTitle}
                  className={styles.select}
                  placeholder="Title"
                  options={titleOptions}
              />
              {errors.title && showErrors ? (
                  <ErrorMsg 
                    className={"ErrorMsg_error"} 
                    type={"error"} 
                    description={"Title is required."} />
              ) : null}
          </div>

          <div className={"col-12 col-sm-6"}>
              <label htmlFor={"firstname"}>
                  First Name
              </label>
              <input
                id={"firstname"}
                className={styles.inputBox}
                placeholder="First Name"
                value={firstname}
                maxLength="50"
                onChange={obj => {
                    setFirstname(obj.target.value);
                }}
              />
              {errors.firstname && showErrors ? (
              <ErrorMsg 
                className={"ErrorMsg_error"}
                type={"error"}
                description={"First Name is required."}
              />
              ) : null}                
          </div>
       
        </div>

        <div className={"row"}>

          <div className="col-12 col-sm-6">
              <label htmlFor={"lastname"}>Last Name</label>
              <input
                id={"lastname"}
                className={styles.inputBox}
                placeholder="Last Name"
                value={lastname}
                maxLength="50"
                onChange={obj => {
                    setLastname(obj.target.value);
                }}
              />
              {errors.lastname && showErrors ? (
              <ErrorMsg 
                className={"ErrorMsg_error"}
                type={"error"}
                description={"Last Name is required."}
              />
              ) : null}                
          </div>

          <div className="col-12 col-sm-6">
              <label htmlFor={"middlename"}>Middle Name (Optional)</label>
              <input
              id={"middlename"}
              className={styles.inputBox}
              placeholder="Middle Name"
              value={middlename}
              maxLength="50"
              onChange={obj => {
                  setMiddlename(obj.target.value);
              }}
              />
          </div>   
          
        </div>

        <div className={"row"}>

          <div className={"col-12 col-sm-6"}>
            <label htmlFor={"dayTimeTelephoneNumber"}>
              Daytime Telephone Number
            </label>
            <input
              id={"dayTimeTelephoneNumber"}
              className={styles.inputBox}
              placeholder="Daytime Telephone Number"
              value={dayTimeTelephoneNumber}
              maxLength="20"
              onChange={obj => {
                setDayTimeTelephoneNumber(obj.target.value);
              }}
            />
            {(dayTimeTelephoneNumber == null || dayTimeTelephoneNumber == "") && errors.dayTimeTelephoneNumber && showErrors ? (
            <ErrorMsg 
              className={"ErrorMsg_error"}
                type={"error"}
                description={"Daytime Telephone Number is required."}
            />
            ) : null}
            {dayTimeTelephoneNumber !== null && dayTimeTelephoneNumber !== "" && errors.dayTimeTelephoneNumber && showErrors ? (
            <ErrorMsg 
              className={"ErrorMsg_error"}
              type={"error"}
              description={"Daytime Telephone Number is invalid."}
            />
            ) : null}  
          </div>

          <div className={"col-12 col-sm-6"}>
              <label htmlFor={"mobileNumber"}>
                  Mobile Number (Optional)
              </label>
              <input
              id={"mobileNumber"}
              className={styles.inputBox}
              placeholder="Mobile Number"
              value={mobileNumber}
              maxLength="20"
              onChange={obj => {
                  setMobileNumber(obj.target.value);
              }}
              />
              {errors.mobileNumber && showErrors ?
                  <ErrorMsg
                  className={"ErrorMsg_error"}
                  type={"error"}
                  description={'Mobile Number is invalid.'}
                  />
              : null}
          </div>            


        </div>

        <div className = "row">
          <div className={"col-12 col-sm-6"}>
            <label htmlFor={"emailAddress"}>
              Email address
            </label>
            <input
              id={"emailAddress"}
              className={styles.inputBox}
              placeholder="Email Address"
              value={emailAddress}
              maxLength="100"
              onChange={obj => {
                setEmailAddress(obj.target.value);
              }}
            />
            {emailAddress != null && emailAddress != "" && errors.email && showErrors ? (
              <ErrorMsg className={"ErrorMsg_error"}
                type={"error"}
                description={"Email Address is invalid."}
              />
            ) : null}
            {errors.emailAddress && showErrors ?            
                <ErrorMsg
                  className={"ErrorMsg_error"}
                  type={"error"}
                  description={'Email Address is required.'}
                />
            : null}   
          </div>
        </div>

        <hr className={styles.hrLine} />

        <div className={"row"}>
          <div className={"col-12"}>
            <h2>Postal Address</h2>
          </div>
        </div>         


        <div className='row'>
          <div className={`col-12 ${styles.addressContainer}`}>

            <AddressWrapped
                international
                autoValidate
                label={null}
                //label={'Postal Address (Australian address only)'}
                // placeholder={'Postal Address (Australian address only)'}
                baseUrl= { getAddresUrlPath() }
                ref={addressRef}
                onChange={(data) => setAddress(data.address)}
                value={address ? {...address, internationalAddressEnabled: false} : {internationalAddressEnabled: false}}
                onValidationChange={setIsAddressValid}
                onWarningChange={setWarnPartialMatch}
                onLoading={setAddressValidating}
            /> 

            {errors.address && showErrors ?

              <ErrorMsg
                  className={"ErrorMsg_error"}
                  type={"error"}
                  description={'Please enter the address and select the right one from the dropdown or complete all the address fields.'}
              /> : null}    

          </div>


        </div>            



    <div className={`row ${styles.buttonCont}`}>
      <div className={`col-12`}>
        <Button 
          disabled = {isAddressValidating}
          onClick={() => {
              var abnAcnResult = componentRef.current.validate();
              if (validate(validators, setErrors) && abnAcnResult) {
                storeData(true);
                setShowErrors(false);
                dispatch(
                  saveImportExportApplication("", () => {
                      props.history.push(`./organisation-dashboard`);
                  })
              ); 
              } else {
                setShowErrors(true);
                scrollToError();
              }                            
            }
          }
        >Continue</Button>

        <Button secondary
          disabled = {isAddressValidating}
          onClick={() => {

            storeData();
            dispatch(
              saveImportExportApplication("", () => {
                  props.history.push(`./organisation-dashboard`);
              })
          );       

          }}
        >
          Save & exit section
        </Button>
      </div>
    </div>

  </div>
  
};

export default withRouter(props => <OrganisationLicenceInformation {...props}/>);
